import configuration from "@intlayer/config/built";
const getTranslation = (languageContent, locale, fallback = true) => {
  const { defaultLocale } = configuration?.internationalization;
  let result = languageContent[locale ?? defaultLocale];
  if (fallback && !result) {
    result = languageContent[defaultLocale];
  }
  return result;
};
export {
  getTranslation
};
//# sourceMappingURL=getTranslation.mjs.map